















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import ErrorField from '@/components/form/ErrorField.vue';
import NumberInput from '@/components/input/NumberInput.vue';

import { CoordinatesValue } from './types';
import { Numeric } from '@/types/common';

@Component({
    components: {
        ErrorField,
        NumberInput,
    } 
})
export default class LocationCoordianates extends Vue {
    @Model('update:coordinates') coordinates!: CoordinatesValue;
    @Prop({ default: '' }) error!: string;

    get latitudeModel() {
        return this.coordinates.latitude;
    }

    set latitudeModel(latitude: Numeric) {
        this.updateCoordinates({
            latitude,
            longitude: this.longitudeModel,
        })
    }

    get longitudeModel() {
        return this.coordinates.longitude;
    }

    set longitudeModel(longitude: Numeric) {
        this.updateCoordinates({
            latitude: this.latitudeModel,
            longitude,
        })
    }

    updateCoordinates(coordinates:  CoordinatesValue) {
        this.$emit('update:coordinates', coordinates)
    }
}
